export enum DisplayDateFormatEnum {
  defaultDisplayDate,
  shotWeekdayAndDate,
}
